const state = {
    titleText: "",
    lang: localStorage.getItem("lang") //"en"
}

const getters = {
    showTitleText: state => {
        return state.titleText
    },
    languageSelected: state => {
        return state.lang
    }
}

// actions
const actions = {
    setTitleText({ commit },  text ) {
        commit("SET_TITLE_TEXT", text)
    },
    setLanguage({commit}, langCode){
        commit("SET_LANGUAGE", langCode)
    }
}

// mutations
const mutations = {
    SET_TITLE_TEXT(state, text) {
        state.titleText = text
    },
    SET_LANGUAGE(state, langCode){
        state.lang = langCode
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
